import styled from 'styled-components'

export default styled.div`
  font-size: 15px;
  padding: 10px;
  background: #a8d7ef;
  border-radius: 3px;
  margin-bottom: 12px;
  position: relative;
`
